import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AlertNotification = ({ alerts, onDismiss, onAction }) => {
  const getAlertStyle = (type) => {
    const styles = {
      warning: {
        bg: 'bg-warning/10',
        border: 'border-warning/20',
        icon: 'AlertTriangle',
        iconColor: 'text-warning'
      },
      success: {
        bg: 'bg-success/10',
        border: 'border-success/20',
        icon: 'CheckCircle',
        iconColor: 'text-success'
      },
      info: {
        bg: 'bg-primary/10',
        border: 'border-primary/20',
        icon: 'Info',
        iconColor: 'text-primary'
      },
      error: {
        bg: 'bg-error/10',
        border: 'border-error/20',
        icon: 'XCircle',
        iconColor: 'text-error'
      }
    };
    return styles?.[type] || styles?.info;
  };

  if (!alerts || alerts?.length === 0) return null;

  return (
    <div className="space-y-3">
      {alerts?.map((alert) => {
        const style = getAlertStyle(alert?.type);
        return (
          <div 
            key={alert?.id}
            className={`${style?.bg} border ${style?.border} rounded-xl p-4 transition-all duration-300`}
          >
            <div className="flex items-start gap-3">
              <div className={`w-10 h-10 rounded-lg bg-white/50 flex items-center justify-center flex-shrink-0`}>
                <Icon name={style?.icon} size={20} className={style?.iconColor} />
              </div>
              <div className="flex-1 min-w-0">
                <h5 className="text-sm font-semibold text-foreground mb-1">{alert?.title}</h5>
                <p className="text-sm text-muted-foreground mb-3">{alert?.message}</p>
                {alert?.action && (
                  <div className="flex gap-2">
                    <Button 
                      variant="outline" 
                      size="xs"
                      onClick={() => onAction(alert?.id, alert?.action)}
                    >
                      {alert?.actionLabel || 'Take Action'}
                    </Button>
                    <Button 
                      variant="ghost" 
                      size="xs"
                      onClick={() => onDismiss(alert?.id)}
                    >
                      Dismiss
                    </Button>
                  </div>
                )}
              </div>
              <button
                onClick={() => onDismiss(alert?.id)}
                className="text-muted-foreground hover:text-foreground transition-colors focus-ring rounded p-1"
                aria-label="Dismiss notification"
              >
                <Icon name="X" size={16} />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AlertNotification;